import React, { createContext, useContext, useState, useMemo } from "react";

const BoxContext = createContext(null);

export const BoxProvider = ({ children }) => {
  // Defaults as requested:
  const [NoteBoxOpen, setNoteBoxOpen] = useState(false); // boolean
  const [NoteBoxID, setNoteBoxID] = useState(null);      // number | null
  const [noteResetCode, setNoteResetCode] = useState(0); // number
  const [selectedNoteId, setSelectedNoteId] = useState(null); // number | null

  const value = useMemo(
    () => ({
      NoteBoxOpen,
      setNoteBoxOpen,
      NoteBoxID,
      setNoteBoxID,
      noteResetCode,
      setNoteResetCode,
      selectedNoteId, // this is saved when clicked so that blue line comes back.. it is cleared on new player
      setSelectedNoteId, // this is saved when clicked so that blue line comes back.. it is cleared on new player
    }),
    [NoteBoxOpen, NoteBoxID, noteResetCode]
  );

  return <BoxContext.Provider value={value}>{children}</BoxContext.Provider>;
};

export const useBoxContext = () => {
  const ctx = useContext(BoxContext);
  if (!ctx) throw new Error("useBoxContext must be used within a BoxProvider");
  return ctx;
};
